import * as React from "react";

import { Link } from "react-router-dom";
import { Page, PageHero, Tabs } from "src/components/common";

import pickListContext from "src/context/pickListContext";
// import axios from 'axios';

interface IProps {
	children?: any;
	match?: any;
	location?: any;
	history?: any;
}
interface IState {
	currentUser: CurrentUserDTO;
}

class ClientTab extends React.Component<IProps, IState> {
	public static contextType = pickListContext;

	public render() {
		const { organizationId, datasetId, clientId } = this.props.match.params;
		const tabs = [
			{
				id: 1,
				label: "Test Results",
				to: `/organizations/${organizationId}/datasets/${datasetId}/clients/${clientId}/results`,
			},
			{
				id: 2,
				label: "Details",
				to: `/organizations/${organizationId}/datasets/${datasetId}/clients/${clientId}/details`,
			},
		];

		return (
			<Page title={`Participant ${clientId}`}>
				<PageHero>
					<Link
						to={`/organizations/${organizationId}/datasets/${datasetId}/clients`}
					>
						&lt; PARTICIPANTS
					</Link>
					<div className="d-flex">
						<h1 className="mb-0">
							{clientId === "-1" ? "New Participant" : `Edit Participant`}{" "}
							Details
						</h1>
					</div>
				</PageHero>
				{clientId === "-1" ? undefined : (
					<Tabs className="mb-4" tabs={tabs} location={this.props.location} />
				)}
				{this.props.children}
			</Page>
		);
	}
}

export default ClientTab;
